import React from 'react';
import { css } from '@emotion/react';

import { FlodeskLogo } from '@/components/ui/FlodeskLogo/FlodeskLogo';

const containerStyles = css`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  align-items: center;
  justify-content: flex-start;
  padding: 80px var(--grn-space-l);
  background-color: var(--grn-color-background);
  gap: var(--grn-space-l);
`;

const headingStyles = css`
  font-family: 'Flodesk Sans', sans-serif;
  font-size: 48px;
  font-weight: var(--grn-weight-medium);
  color: var(--grn-color-content);
  margin: 0 0 var(--grn-space-l);
  text-align: center;
  line-height: 1.05;
  white-space: nowrap;

  @media (max-width: 640px) {
    font-size: 28px;
  }
`;

const subheadingStyles = css`
  font-family: 'Flodesk Sans', sans-serif;
  font-size: var(--grn-text-l);
  font-weight: var(--grn-weight-normal);
  color: var(--grn-color-content2);
  margin: 0;
  text-align: center;
  line-height: 1.6;
`;

export default function Home() {
  return (
    <div css={containerStyles}>
      <FlodeskLogo />
      <div>
        <h1 css={headingStyles}>Your blank canvas is ready</h1>
        <p css={subheadingStyles}>
          This is your starting point. Describe what you want to build and it happens.
        </p>
      </div>
    </div>
  );
}
